import { css } from 'styled-components';
import { StyledRteHtmlText } from './StyledRteHtmlText.tsx';

export const StyledRteHtmlTextGuide = css<{ c?: string }>`
  // Stili dedicati per la guida alla compilazione
  ${StyledRteHtmlText}

  font-size: 18px;
  line-height: 1.7;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.01em;
    margin-bottom: 0.3em;
  }
`;
